<template>
  <div>
    <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }">
      <v-combobox
        v-model="editedItem"
        :items="allItem"
        :search-input.sync="searchInput"
        :item-text="setItemText"
        :item-value="(item) => item.Number + item.Name"
        required
        return-object
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_results')"
        @change="chooseItem"
        :error-messages="errors[0]"
        :ref="refName"
        @keyup.enter="keyupEnter"
      >
        <template v-slot:append-item>
          <div v-intersect="isScrollBarBottom" />
        </template>
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title>{{ data.item.Number }}</v-list-item-title>
              <v-list-item-subtitle>{{ data.item.Name }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon v-if="!data.item.disabled">
              <v-icon color="green" class="mr-2"> mdi-check </v-icon>
            </v-list-item-icon>
            <v-list-item-icon v-if="data.item.disabled">
              <v-icon color="grey" class="mr-2"> mdi-close </v-icon>
            </v-list-item-icon>
          </template>
        </template>
        <template slot="append">
          <v-tooltip top color="red lighten-5">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="grey" dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>
              <v-icon color="green" class="mr-2"> mdi-check </v-icon>
              <span style="color: green">
                {{ $t('quotation_item_new_exist') }}
              </span>
            </span>
            <br />
            <span>
              <v-icon color="grey" class="mr-2"> mdi-close </v-icon>
              <span style="color: grey">
                {{ $t('quotation_item_new_no_exist') }}
              </span>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:selection="{ item }">
          {{ setSelectText(item) }}
        </template>
        <template v-slot:label>
          <span class="red--text">
            <strong>* </strong>
          </span>
          {{ $t(itemName) }}
        </template>
      </v-combobox>
    </ValidationProvider>
  </div>
</template>

<script>
import { HttpItem } from '@/js/http-Manager'
export default {
  name: 'QuotationItemForRepairPriceCombobox',
  props: {
    fatherEditedItem: {
      type: Object
    },
    editedItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    repairCustomerId: {
      type: String
    },
    refName: {
      type: String
    },
    customerDeviceType: {
      type: Number
    }
  },
  components: {},
  data: () => ({
    allItem: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchItem: '',
    searchCount: 0,
    isGetItemFinish: false,
    isLoadingItem: false,
    getIntersectingObj: null,
    editedItem: {
      Id: '',
      Number: '',
      Name: ''
    },
    defaultItem: {
      Id: '',
      Number: '',
      Name: ''
    }
  }),
  async mounted () {
    await this.getItemsCount()
    await this.getItems()
    this.page = 0
  },
  watch: {
    async searchInput (val) {
      this.tempWatchItem = val
      this.page = 1
      this.allItem = []
      this.isGetItemFinish = true
      await this.getItemsCount()
      await this.getItems()
      this.isGetItemFinish = false
    },
    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetItemFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getItems()
        }
      }
    },
    async fatherEditedItem (val) {
      if (val.Name === '') {
        this.tempWatchItem = ''
        this.page = 1
        this.allItem = []
        this.isGetItemFinish = true
        await this.getItemsCount()
        await this.getItems()
        this.isGetItemFinish = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      } else {
        this.editedItem = JSON.parse(JSON.stringify(val))
      }
    },
    async customerDeviceType (oldVal, newVal) {
      if (
        ((oldVal === 0 || oldVal === 3) && (newVal === 1 || newVal === 2)) ||
        ((oldVal === 1 || oldVal === 2) && (newVal === 0 || newVal === 3))
      ) {
        this.tempWatchItem = this.editedItem.Number
        this.page = 1
        this.allItem = []
        this.isGetItemFinish = true
        await this.getItemsCount()
        await this.getItems()
        this.isGetItemFinish = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.$emit('setEditedItem', this.defaultItem)
      }
    }
  },
  methods: {
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    chooseItem () {
      if (typeof this.editedItem === 'string') {
        this.editedItem = JSON.parse(
          JSON.stringify({
            Number: '',
            Name: this.editedItem,
            Quantity: 0,
            Price: 0,
            WarrantyPeriod: 0
          })
        )
      }
      if (this.editedItem) {
        this.$emit('setEditedItem', this.editedItem)
      } else {
        this.$emit('setEditedItem', this.defaultItem)
      }
    },
    setSelectText (item) {
      return item.Name
    },
    setItemText (item) {
      return item.Number + ' - ' + item.Name
    },
    async getItemsCount () {
      let param = {
        searchItem: this.tempWatchItem,
        customerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
      }

      let response = await HttpItem.GetFilterTypeItemAndAuthorizeCount(param)

      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getItems () {
      if (
        this.editedItemIndex === -1 &&
        this.searchCount > (this.page - 1) * this.perPage &&
        this.searchCount !== 0
      ) {
        this.isLoadingItem = true
        let param = {
          CustomerId: this.repairCustomerId,
          SearchItem: this.tempWatchItem,
          Page: this.page,
          PerPage: this.perPage,
          CustomerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
        }
        let response = await HttpItem.GetQuotationItemRepairPrice(param)
        if (response.status === 200) {
          this.allItem = [...this.allItem, ...response.data.Data]
        } else {
          this.allItem = []
        }
        this.isLoadingItem = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    }
  }
}
</script>
